export default {
    namespaced: true,
    state: () => ({
        brand : {
            id : null,
            brand_id: null,
            company_name: null,
            brand_name : null,
            department_name: null,
            url: null,
            zip_code: null,
            address: null,
            remarks: null,
            phone_number: null,
        },
        selectedBrandId: null
    }),
    getters: {
        data(state) {
            return state.brand
        },
        id (state) {
            return state.brand.id
        },
        brandId (state) {
            return state.brand.brand_id
        },
        name (state) {
            return state.brand.brand_name
        },
        url (state) {
            return state.brand.url
        },
        path (state) {
            return state.brand.url ? state.brand.url.split('/')[3] : ''
        },
        selectedBrandId (state) {
            return state.selectedBrandId
        }
    },
    mutations: {
        setBrand(state, payload) {
            state.brand = payload
        },
        setBrandId(state, payload) {
            state.selectedBrandId = payload
        },
        setBrandUrl(state, payload) {
            state.brand.url = payload
        },
        clearBrandId(state) {
            state.selectedBrandId = null
        },
        clear(state) {
            const brand = {
                id : null,
                brand_id: null,
                company_name: null,
                brand_name : null,
                department_name: null,
                url: null,
                zip_code: null,
                address: null,
                remarks: null,
                phone_number: null,
            }
            state.brand = brand
            state.selectedBrandId = null
        }
    },
    actions: {
        async fetchBrand({commit}, {axios, endpoint, brandPath}) {
            let brand = {}
            const res = await axios.post(endpoint + 'common/brand/path/verify', {
                path: brandPath
            })

            const data = res.data.brand
            brand.address = data.address
            brand.brand_id = data.brandId
            brand.brand_name = data.brandName
            brand.company_name = data.companyName
            brand.create_datetime = data.createDatetime
            brand.department_name = data.departmentName
            brand.id = data.id
            brand.phone_number = data.phoneNumber
            brand.remarks = data.remarks
            brand.url = data.url
            brand.zip_code = data.zipCode

            commit('setBrand', brand)
        },
        doUpdate({ commit }, brand) {
            commit('setBrand', brand)
        },
        setBrandId({ commit }, selectedBrandId) {
            commit('setBrandId', selectedBrandId )
        },
        setBrandUrl({ commit }, url) {
            commit('setBrandUrl', url )
        },
        clearBrandId({ commit }) {
            commit('clearBrandId')
        },
        doClear({ commit }) {
            commit('clear')
        }
    },
}
